
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#FCFDFF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.359 2H7.64C4.256 2 2 4.42 2 7.893v8.214C2 19.583 4.25 22 7.641 22h8.718C19.75 22 22 19.583 22 16.107V7.893C22 4.417 19.75 2 16.359 2zM7.64 3.395h8.718c2.597 0 4.246 1.77 4.246 4.498v8.214c0 2.727-1.649 4.498-4.246 4.498H7.64c-2.597 0-4.246-1.77-4.246-4.498V7.893c0-2.724 1.654-4.498 4.246-4.498zM12 7.885c.353 0 .645.263.691.604l.007.095v2.71h2.713a.698.698 0 01.095 1.388l-.095.007h-2.713v2.71a.698.698 0 01-1.39.094l-.006-.094v-2.71H8.59a.698.698 0 01-.095-1.39l.095-.005h2.713v-2.71c0-.386.313-.698.698-.698z","fill":"inherit"}})])
          )
        }
      }
    